import { TourConfig, TourId } from "./types";

const tours = new Map<TourId, TourConfig>();

export function registerTour(config: TourConfig): void {
  tours.set(config.id, config);
}

export function getTour(id: TourId): TourConfig | undefined {
  return tours.get(id);
}

export function getTours(): TourConfig[] {
  return Array.from(tours.values());
}

export function findTourForRoute(
  pathname: string,
  role: string | undefined
): TourConfig | undefined {
  for (const tour of tours.values()) {
    if (!tour.route.test(pathname)) continue;
    if (tour.roleGate && !tour.roleGate(role)) continue;
    return tour;
  }
  return undefined;
}
